<template>
    <LayoutDefault :title-page="'Importar Exames de Clientes Integrados'">
        <ImportControls name="import"/>
        <SearchResult v-if="canShowTable"></SearchResult>
        <h2 v-if="getImportMessage">{{ getImportMessage }}</h2>
    </LayoutDefault>
</template>

<style>
</style>

<script>
    import LayoutDefault from "@/templates/LayoutDefault";
    import ImportControls from "@/components/tuevs/ImportControls";
    import SearchResult from "@/components/tuevs/SearchResult";
    import {mapGetters} from 'vuex';

    export default {
        name: "Import",
        components: {LayoutDefault, ImportControls, SearchResult},
        computed: {
            ...mapGetters({
                canShowTable: 'tuevs/getCanShowTable',
                getImportMessage: 'tuevs/getImportMessage'
            })
        },
    }
</script>
